export const ErrorParse = (error) => {
    let msn = error.message;
    if (error.response) {
        if(error.response.data) {
            msn = error.response.data.message
        }
    }
    return msn;
}